import { styled } from "@mui/system";
import Paper from "@mui/material/Paper";
import theme from "../theme";

export interface SamaggiPaperProps {
    vertical?: boolean,
    mobile?: boolean,
    wide?: boolean,
    noPad?: boolean,
    maxWidth?: boolean,
    noMargin?: boolean,
}

const SamaggiPaper = styled(Paper, {
    shouldForwardProp: (prop) => !["vertical", "mobile", "wide", "noPad", "maxWidth", "noMargin"].includes(prop as string)
}) <SamaggiPaperProps> (({vertical, mobile, wide = false, noPad = false, maxWidth = false, noMargin = false}) => ({
    padding: noPad? "0" : "30px",
    borderRadius: `${theme.shape.borderRadius * 5}px ! important`,
    marginTop: noMargin ? "0" : (mobile ? "30px" : "50px"),
    marginLeft: noMargin ? "0" : (vertical ? "2vw" : "10px"),
    marginRight: noMargin ? "0" : (vertical ? "2vw" : "10px"),
    marginBottom: noMargin ? "0" : (mobile ? "30px" : "50px"),
    width: maxWidth? "100%" : (wide? "600px" : "425px"),
    maxWidth: noMargin ? "100vw" : "86vw",
    boxSizing: "border-box"
}))

export default SamaggiPaper

